import { gql, useMutation, useQuery } from '@apollo/client';

const LIST = gql`
  query Rules {
    moderation_rules(order_by: { created_at: desc }) {
      id name type pattern action active created_at
    }
  }
`;

const TOGGLE = gql`
  mutation Toggle($id: uuid!, $active: Boolean!) {
    update_moderation_rules_by_pk(pk_columns: { id: $id }, _set: { active: $active }) { id active }
  }
`;

type Rule = {
  id: string;
  name: string | null;
  type: string | null;
  pattern: string | null;
  action: string | null;
  active: boolean;
  created_at: string;
};

export function ModerationRulesPage() {
  const { data, loading, refetch } = useQuery(LIST);
  const [toggle] = useMutation(TOGGLE);
  const rules: Rule[] = data?.moderation_rules ?? [];

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h2 className="page-title">Moderations-Regeln</h2>
          <p className="page-sub">
            Keyword-, Regex- oder LLM-Prompt-Regeln. Aktionen: block · flag · pass.
          </p>
        </div>
      </div>
      {loading && <div className="loader">Regeln werden geladen…</div>}
      {!loading && (
        <div className="card" style={{ padding: 0 }}>
          <table className="tbl">
            <thead>
              <tr>
                <th>Name</th>
                <th>Typ</th>
                <th>Pattern</th>
                <th>Aktion</th>
                <th>Aktiv</th>
              </tr>
            </thead>
            <tbody>
              {rules.map((r) => (
                <tr key={r.id}>
                  <td>{r.name}</td>
                  <td>
                    <span className="chip">{r.type}</span>
                  </td>
                  <td className="mono" style={{ color: 'var(--fg-2)' }}>{r.pattern}</td>
                  <td>{r.action}</td>
                  <td>
                    <button
                      type="button"
                      className={`switch${r.active ? ' on' : ''}`}
                      onClick={async () => {
                        await toggle({ variables: { id: r.id, active: !r.active } });
                        refetch();
                      }}
                      aria-label={r.active ? 'Deaktivieren' : 'Aktivieren'}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
